import React from 'react';
import { Image, View } from "react-native"
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { ArticleProps } from "../../../store/types/soc_svc"
import StreamCard from '../components/StreamCard';

type NewsArticleProps = {
    article:ArticleProps,
    width:number,
    onSelect: (artice:ArticleProps) => void
}

const NewsArticle = ({ article, width, onSelect }:NewsArticleProps) => {

    if(!article.image){ return <></> }
    return (
        <TouchableOpacity onPress={() => onSelect(article)}>
            {article.article_type == 'video' ?
            <View>
                <StreamCard
                    id={article.article_id}
                    url={article.url}
                    width={width}
                    stream_type={article.video_type}
                />
                <View style={{ backgroundColor:Colors.shades.shade100, padding:10 }}>
                    <Text size={12} color={Colors.brand.midnight} weight='semibold'>{article.title}</Text>
                    <Text style={{ marginTop:3 }} size={12} color={Colors.brand.midnight} weight='regular'>{article.content_snippet}</Text>
                </View>
            </View>
            :
            <View>
                <Image source={article.image.url} style={{ height:width*0.6, width }} resizeMode='cover'/>
                <View style={{ backgroundColor:Colors.shades.shade100, padding:10 }}>
                    <Text size={12} color={Colors.brand.midnight} weight='semibold'>{article.title}</Text>
                    <Text style={{ marginTop:3 }} size={12} color={Colors.brand.midnight} weight='regular'>{article.content_snippet}</Text>
                </View>
            </View>
            }
        </TouchableOpacity>
    )
}

export default NewsArticle